import React, { useEffect, useState, useCallback } from "react";
import "../../../Util.css";
import "./List.css";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { ChevronDown, MoveLeft } from "lucide-react";
import CommonDropdown from "../../common/common_dropDown";
import CommonStaticDropdown from "../../common/common_static_dropdown";
import SearchWithFreeText from "../../common/common_auto_freesuggestion";
import { getCategoryField, getMaintenCategApi, getVehicleEditDetAPI, getVehicleNoDetAPI, saveAttachmentApi, submitAPI, UpdateAPI, getEparivahanAPI } from "./vehicle_api";
import attachment from "../../../assets/png/attachment.png";
import download from "../../../assets/svg/download.svg";
import closeAttachment from "../../../assets/svg/close-red.svg";
import ErrorExtractor from "../../common/error_extractor";
import DOMPurify from "dompurify";
import fields from "../../../assets/svg/customize.svg";
import close from "../../../assets/svg/close.svg";
import save from "../../../assets/svg/save.svg";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { DocUploader } from "../../common/DocUploader";
import trash from "../../../assets/svg/trash.svg";
import RCDetailsCard from "../../common/common_vehicle_details";
import { apiDateToDate } from "../../common/helper-func";

// --- Constants & Helpers ---

const MONTH_MAP = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11,
};
const parseYYYYMMDD = (dateStr) => {
  if (!dateStr) return null;

  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const parseApiDate = (dateStr) => {
  if (!dateStr) return null;

  // Expected format: DD-MMM-YYYY (e.g. 10-Jan-2018)
  const parts = dateStr.split("-");
  if (parts.length !== 3) return null;

  const [day, monthStr, year] = parts;
  const monthIndex = MONTH_MAP[monthStr];

  if (monthIndex === undefined) return null;

  return new Date(Number(year), monthIndex, Number(day));
};

const formatBytes = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const downloadFile = (fileUrl, fileName) => {
  fetch(fileUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => console.error("Download error:", error));
};

const formatDateToYMD = (dateInput) => {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const convertServiceListToBackend = (serviceList) => {
  return serviceList.map((service) => ({
    id: service.id,
    category: service.name,
    services: service.fields.map((field) => ({
      id: field.id || "", // convert null to empty string
      title: field.name,
      km: field.kilometer || "",
      period: field.period || "",
      type: field.periodValue || "",
    })),
  }));
};

const STATUS_LIST = [
  { label: "Active", value: true },
  { label: "In-Active", value: false },
];

const FUEL_TYPE_LIST = [
  { label: "Petrol", value: "Petrol" },
  { label: "Diesel", value: "Diesel" },
  { label: "Gas", value: "Gas" },
  { label: "Electric", value: "Electric" },
];

const OWNERSHIP_LIST = [
  { label: "Dedicated", value: "Dedicated" },
  { label: "Marketed", value: "Marketed" },
];

const PERIOD_OPTIONS = ["Years", "Months", "Weeks", "Days"];

const INITIAL_ERROR_MSG = {
  code: "",
  name: "",
  lic_no: "",
  vin: "",
  year_of_make: "",
  km: "",
  fuel_type: "",
  status: "",
  ownership: "",
  load_capacity: "",
  length: "",
  breadth: "",
  height: "",
  uom: "",
  vehicle_value: "",
  currency: "",
  lifetime: "",
  lifetime_period: "",
  maintenance: "",
  images: "",
  removed_images: "",
  removed_maintenance: "",
  removed_service: "",
  vehicle_type: "",
  make: "",
  model: "",
  trim: "",
  color: "",
  body_type: "",
  body_sub_type: "",
  location: "",
  operation: "",
};

export const NewVehicle = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const location = useLocation();
  const { id } = location.state || {};
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [activeBtn, setActiveBtn] = useState("details");

  // RC, Insurance, Permit State
  const [expiryDate, setExpiryDate] = useState();
  const [rcNo, setRcNo] = useState();
  const [rcStatus, setRcStatus] = useState();

  const [expiryInsDate, setExpiryInsDate] = useState();
  const [insNo, setInsNo] = useState();
  const [insStatus, setInsStatus] = useState();

  const [expiryPermitDate, setExpiryPermitDate] = useState();
  const [permitNo, setPermitNo] = useState();
  const [permitStatus, setPermitStatus] = useState();

  // Services State
  const [serviceList, setServices] = useState([]);
  const [deletedFields, setDeletedFields] = useState([]);
  const [deletedServiceIds, setDeletedServiceIds] = useState([]);

  // Attachments State
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);

  // Modal State
  const [showCustomize, setShowCustomize] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [showAdd, setShowAdd] = useState(true);
  const [showCategory, setShowCategory] = useState(true);
  const [inputValue, setInputValue] = useState("");

  const [maintenanceList, setMaintenanceList] = useState([]);
  const [categoryField, setCategoryField] = useState([]);

  // Vehicle Info State
  const [name, setname] = useState("");
  const [code, setcode] = useState("");
  const [vin, setvin] = useState("");
  const [licensePlate, setlicensePlate] = useState("");
  const [makeBrand, setmakeBrand] = useState("");
  const [makeYear, setmakeYear] = useState("");
  const [makeKiloMeter, setKiloMeter] = useState("");
  const [makeModel, setModel] = useState("");
  const [operationvalue, setoperationvalue] = useState("");
  const [colorvalue, setColorvalue] = useState("");
  const [bodytypevalue, setbodytypevalue] = useState("");
  const [bodySubtypevalue, setbodySubtypevalue] = useState("");
  const [loadCapacvalue, setloadCapacvalue] = useState("");
  const [moreinfoLvalue, setmoreinfoLvalue] = useState("");
  const [moreinfoRvalue, setmoreinfoRvalue] = useState("");
  const [moreinfoHvalue, setmoreinfoHvalue] = useState("");
  const [vehilcevalue, setVehiclevalue] = useState("");
  const [vehilceLifevalue, setVehicleLifevalue] = useState("");

  const [selectedUnit, setSelectedUnit] = useState("cm");
  const [selectedValueType, setSelectedValueType] = useState("INR");
  const [selectedLifeValue, setSelectedLifeValue] = useState("Year");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedFuelType, setSelectedFuelType] = useState(null);
  const [selectedOwnerShip, setSelectedOwnerShip] = useState(null);
  const [selectedTrim, setSelectedTrim] = useState(null);
  const [searchTrim, setSearchTrim] = useState("");
  const [selectedvehType, setSelectedvehType] = useState(null);
  const [searchVehType, setSearchVehType] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isFetch, setIsFetch] = useState(false);

  const [isParivahan, setIsParivahan] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const resetVehicleDetails = () => {
    setRcNo("");
    setExpiryDate(null);
    setRcStatus("");

    setInsNo("");
    setExpiryInsDate(null);
    setInsStatus("");

    setPermitNo("");
    setExpiryPermitDate(null);
    setPermitStatus("");
    setIsFetch(false);
  };

  const [errorMsg, setErrorMsg] = useState(INITIAL_ERROR_MSG);

  // --- Effects ---

  useEffect(() => {
    getMaintenCateg();
    getEparivahan();
  }, []);

  useEffect(() => {
    if (id != null) {
      getVehicleDetails();
    }
  }, [id]);

  // --- API Handlers ---
  const getEparivahan = async () => {
    try {
      const response = await getEparivahanAPI();
      if (response.data?.success) {
        setIsParivahan(response.data.is_true ? true : false);
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  const getMaintenCateg = async () => {
    try {
      const response = await getMaintenCategApi();
      if (response.data?.success) {
        const tempList = response.data.suggestionlist.map((item) => ({
          ...item,
          checked: false,
        }));
        setMaintenanceList(tempList);
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };

  const getVehicleDetails = async () => {
    try {
      const response = await getVehicleEditDetAPI(id);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle;

        // Populate state
        setvin(vehicleData.vin || "");
        setcode(vehicleData.code || "");
        setname(vehicleData.vehicle_name || "");
        setmakeBrand(vehicleData.make || "");
        setmakeYear(vehicleData.year_of_make || "");
        setModel(vehicleData.model || "");
        setKiloMeter(vehicleData.km || "");
        setlicensePlate(vehicleData.lic_no || "");
        setoperationvalue(vehicleData.operation || "");
        setSelectedValueType(vehicleData.currency || "");
        setSelectedUnit(vehicleData.uom || "");
        setSelectedvehType({
          label: vehicleData.type_label || "",
          value: vehicleData.type_value || "",
        });
        setSelectedFuelType({
          label: vehicleData.fuel_type || "",
          value: vehicleData.fuel_type || "",
        });
        setSelectedLocation({
          label: vehicleData.location_name || "",
          value: vehicleData.location_id || "",
        });
        setSelectedOwnerShip({
          label: vehicleData.ownership || "",
          value: vehicleData.ownership || "",
        });
        setSelectedTrim({
          label: vehicleData.trim || "",
          value: vehicleData.trim || "",
        });
        setSearchTrim(vehicleData.trim);
        setSelectedStatus({
          label: vehicleData.status === true ? "Active" : "In-Active",
          value: vehicleData.status,
        });

        setVehiclevalue(vehicleData.value || "");
        setColorvalue(vehicleData.color || "");
        setbodytypevalue(vehicleData.bodytype || "");
        setbodySubtypevalue(vehicleData.bodysubtype || "");
        setloadCapacvalue(vehicleData.loadcapacity || "");
        setmoreinfoLvalue(vehicleData.length || "");
        setmoreinfoRvalue(vehicleData.breadth || "");
        setmoreinfoHvalue(vehicleData.height || "");
        setVehicleLifevalue(vehicleData.lifetime || "");
        setAttachmentURLList(vehicleData.images ?? []);

        setRcNo(vehicleData.rc_number ?? "");
        setRcStatus(vehicleData.rc_status);
        setExpiryDate(apiDateToDate(vehicleData.rc_valid_upto ?? ""));

        setExpiryInsDate(apiDateToDate(vehicleData.insurance_upto ?? ""));
        setInsNo(vehicleData.insurance_company ?? "");
        setInsStatus(vehicleData.insurance_status ?? "");

        setExpiryPermitDate(apiDateToDate(vehicleData.permit_valid_upto ?? ""));
        setPermitNo(vehicleData.permit_number ?? "");
        setPermitStatus(vehicleData.permit_status ?? "");

        if (vehicleData.maintenance?.length > 0) {
          const formattedMaintenance = vehicleData.maintenance.map((m) => ({
            id: m.id,
            name: m.category,
            fields: m.services.map((s) => ({
              id: s.id,
              name: s.title,
              kilometer: s.km,
              period: s.period,
              periodValue: s.type,
            })),
          }));
          setServices(formattedMaintenance);
        }
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };

  const getLicenseDetails = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const data = { vehicle_number: licensePlate };
      const response = await getVehicleNoDetAPI(data);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle_data;
        setRcNo(vehicleData.registration_certificate_number ?? "");
        setExpiryDate(parseYYYYMMDD(vehicleData.registration_certificate_valid_upto ?? ""));
        setRcStatus(vehicleData.rc_status ?? "");
        setInsNo(vehicleData.insurance_company ?? "");
        setExpiryInsDate(parseYYYYMMDD(vehicleData.insurance_upto ?? ""));
        setInsStatus(vehicleData.insurance_status ?? "");
        setPermitNo(vehicleData.permit_number === "undefined" ? "" : (vehicleData.permit_number ?? ""));
        setExpiryPermitDate(parseYYYYMMDD(vehicleData.permit_valid_upto ?? ""));
        setPermitStatus(vehicleData.permit_status ?? "");
        setErrorMsg((prev) => ({ ...prev, lic_no: "" }));
        setIsFetch(true);
      } else {
        setErrorMsg((prev) => ({ ...prev, lic_no: response.data.message }));
        setIsFetch(false);
      }
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
      const errorMessage = err.response?.data?.message || "Error fetching vehicle details";
      setErrorMsg((prev) => ({ ...prev, lic_no: errorMessage }));
      setSnackbarMessage(errorMessage);
      setSnackbarStatus(false);
      setIsFetch(false);
      handleSnackbarShow();
    } finally {
      setLoading(false);
    }
  };

  const getCategField = async (id) => {
    try {
      const response = await getCategoryField(id);
      if (response.data?.success) {
        const tempList = response.data.suggestionlist.map((item) => ({
          ...item,
          checked: true,
        }));
        setCategoryField(tempList);
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };

  const saveAttachment = async (workOrderId) => {
    try {
      const data = {
        attachment: attachmentList.map((item) => item.base64),
      };
      const response = await saveAttachmentApi(workOrderId, data);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    }
  };

  // --- Event Handlers ---

  const handleSnackbarShow = () => setShowSnackbar(true);

  const handleShowCustomize = () => {
    setShowCustomize(true);
    setShowCategory(true);
    setSelectedCategory(null);
    setCategoryField([]);
    setShowInput(false);
    setShowAdd(true);
  };

  const handleDeleteService = useCallback((serviceIndex) => {
    setServices((prevList) => {
      const serviceToDelete = prevList[serviceIndex];
      setDeletedServiceIds((prevIds) => [...prevIds, serviceToDelete.id]);
      return prevList.filter((_, idx) => idx !== serviceIndex);
    });
  }, []);

  const handleFieldsDelete = useCallback((serviceIndex, fieldIndex) => {
    setServices((prevList) => {
      const newList = [...prevList];
      const fieldToDelete = newList[serviceIndex].fields[fieldIndex];
      setDeletedFields((prev) => [...prev, fieldToDelete.id]);
      newList[serviceIndex] = {
        ...newList[serviceIndex],
        fields: newList[serviceIndex].fields.filter((_, idx) => idx !== fieldIndex),
      };
      return newList;
    });
  }, []);

  const addService = () => {
    setShowCustomize(false);
    setServices((prevServices) => {
      const newFields = categoryField
        .filter((item) => item.checked === true)
        .map((item) => ({
          name: item.label,
          category_id: item.value,
          id: "",
          kilometer: "",
          period: "",
          periodValue: "",
        }));

      const existingServiceIndex = prevServices.findIndex((service) => service.name === (selectedCategory ? selectedCategory.label : ""));

      if (existingServiceIndex !== -1) {
        const updatedServices = [...prevServices];
        const existingFields = updatedServices[existingServiceIndex].fields;
        const filteredNewFields = newFields.filter((f) => !existingFields.some((ef) => ef.name === f.name));
        updatedServices[existingServiceIndex].fields = [...existingFields, ...filteredNewFields];
        return updatedServices;
      } else {
        return [
          ...prevServices,
          {
            name: selectedCategory ? selectedCategory.label : "",
            id: "",
            fields: newFields,
          },
        ];
      }
    });
    setShowAdd(true);
    setShowInput(false);
  };

  // Replaces handleKilometerChange, handlePeriodChange, handlePeriodValueChange
  const handleServiceFieldChange = useCallback((serviceIndex, fieldIndex, key, value) => {
    setServices((prevServices) => {
      const updatedServices = [...prevServices];
      updatedServices[serviceIndex] = {
        ...updatedServices[serviceIndex],
        fields: updatedServices[serviceIndex].fields.map((field, idx) => (idx === fieldIndex ? { ...field, [key]: value } : field)),
      };
      return updatedServices;
    });
  }, []);

  const toggleCheckbox = (index) => {
    const updated = [...maintenanceList];
    updated[index].checked = !updated[index].checked;
    setMaintenanceList(updated);
  };

  const toggleCategoryCheckbox = (index) => {
    const updated = [...categoryField];
    updated[index].checked = !updated[index].checked;
    setCategoryField(updated);
  };

  const handleSave = () => {
    if (inputValue.trim() === "") return;
    setMaintenanceList((prev) => [...prev, { label: inputValue, value: inputValue, checked: true }]);
    setShowAdd(true);
    setShowInput(false);
    setInputValue("");
  };

  const handleCategorySave = () => {
    if (inputValue.trim() === "") return;
    setCategoryField([...categoryField, { label: inputValue, value: inputValue, checked: false }]);
    setShowAdd(true);
    setShowInput(false);
    setInputValue("");
  };

  const handleSelectCategory = (item) => {
    setSelectedCategory(item);
    if (item.value != null && typeof item.value === "number") {
      getCategField(item.value);
    } else {
      console.error("Invalid value:", item.value);
    }
  };

  const handleDropdownTrimChange = (option) => {
    setSelectedTrim(option);
    setSearchTrim(option.value ?? "");
  };

  const handleSearchTrimChange = (value) => {
    setSearchTrim(value);
    setSelectedTrim({ label: value, value: value });
  };

  const submitForm = async () => {
    setIsLoader(true);
    setErrorMsg(INITIAL_ERROR_MSG);

    const extractor = new ErrorExtractor();

    const backendData = convertServiceListToBackend(serviceList);
    try {
      const preSanitizeData = {
        code,
        name,
        lic_no: licensePlate,
        vin,
        year_of_make: makeYear,
        km: makeKiloMeter,
        fuel_type: selectedFuelType?.value ?? null,
        status: selectedStatus?.value ?? "",
        ownership: selectedOwnerShip?.value ?? "",
        load_capacity: loadCapacvalue,
        length: moreinfoLvalue,
        breadth: moreinfoRvalue,
        height: moreinfoHvalue,
        uom: selectedUnit,
        value: vehilcevalue,
        currency: selectedValueType,
        lifetime: vehilceLifevalue,
        lifetime_period: selectedLifeValue,
        maintenance: backendData,
        removed_images: removedAttachmentList ?? [],
        removed_maintenance: deletedFields,
        removed_service: deletedServiceIds,
        vehicle_type: selectedvehType?.value ?? "",
        make: makeBrand,
        model: makeModel,
        trim: selectedTrim?.value ?? searchTrim,
        color: colorvalue,
        body_type: bodytypevalue,
        body_sub_type: bodySubtypevalue,
        location: selectedLocation?.value ?? "",
        operation: operationvalue,
        registration_certificate_number: rcNo,
        registration_certificate_valid_upto: formatDateToYMD(expiryDate),
        rc_status: rcStatus,
        insurance_company: insNo,
        insurance_upto: formatDateToYMD(expiryInsDate),
        insurance_status: insStatus,
        permit_number: permitNo,
        permit_valid_upto: formatDateToYMD(expiryPermitDate),
        permit_status: permitStatus,
        is_fetch: isFetch,
      };

      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });

      let response;
      if (id == null) {
        response = await submitAPI(sanitizedData);
      } else {
        response = await UpdateAPI(sanitizedData, id);
      }

      if (response.status === 400 || response.data.success === false) {
        const validationTemp = { ...errorMsg };
        if (typeof response.data.error === "object" && response.data.error !== null) {
          Object.entries(response.data.error).forEach(([key, value]) => {
            validationTemp[key] = Array.isArray(value) ? (value.length === 0 ? "" : value[0]) : value;
          });
        } else if (typeof response.data.error === "string") {
          validationTemp.lic_no = response.data.error;
        }
        setErrorMsg(validationTemp);
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        if (attachmentList.length === 0) {
          navigate(-1);
        } else {
          await saveAttachment(response.data.id);
        }
      }
      return response.data;
    } catch (err) {
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };

  const handleCancel = () => navigate("/list");

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="w-100 bg-half-white">
          <div
            className="d-flex align-items-center justify-content-between bg-white "
            style={{
              borderTop: "1px solid #EBEBEB",
              borderBottom: "1px solid #EBEBEB",
              paddingRight: "16px",
              paddingLeft: "16px",
            }}
          >
            <div className="d-flex gap-3 my-3">
              <MoveLeft className="cursor-pointer" onClick={handleCancel} />
              <p className="fw-semibold m-0">New vehicle</p>
            </div>
            <div className="d-flex gap-3">
              <Button className="bg-white rounded-pill px-4 py-2 pagination-color btn-border-grey" onClick={handleCancel}>
                Cancel
              </Button>
              <Button className={`d-flex justify-content-center dark-purple-btn ${isLoader ? "disabled-btn" : ""} rounded-pill py-2 px-4`} onClick={submitForm} style={{ minWidth: "100px" }}>
                {isLoader ? <Spinner animation="border" size="sm" /> : id !== null && id !== undefined ? "Update" : "Save"}
              </Button>
            </div>
          </div>
          <div style={{ paddingLeft: "16px", paddingRight: "16px" }}>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex gap-3 my-3">
                <Button className={`rounded-pill px-4 py-2 ${activeBtn === "details" ? "dark-purple-btn" : "bg-white pagination-color btn-border-grey"}`} onClick={() => setActiveBtn("details")}>
                  Details
                </Button>

                <Button className={`rounded-pill px-4 py-2 ${activeBtn === "maintenance" ? "dark-purple-btn" : "bg-white pagination-color btn-border-grey"}`} onClick={() => setActiveBtn("maintenance")}>
                  Maintenance
                </Button>
              </div>
              {activeBtn === "maintenance" && (
                <>
                  <Button className="bg-white rounded-pill d-flex align-items-center px-4 py-2 btn-border-grey gap-2" onClick={handleShowCustomize}>
                    <img src={fields} alt="" />
                    <span style={{ color: "#471070" }}>Customize fields</span>
                  </Button>
                  <Modal show={showCustomize} onHide={() => setShowCustomize(false)} centered size="md" dialogClassName="custom-modal">
                    <Modal.Header>
                      <Modal.Title>Customize</Modal.Title>
                      <button
                        type="button"
                        onClick={() => setShowCustomize(false)}
                        style={{
                          border: "2px solid #EBEBEB",
                          borderRadius: "50%",
                        }}
                        className="btn-close"
                      />
                    </Modal.Header>

                    <Modal.Body>
                      <div className="d-flex mb-3 w-100 px-2 py-1 rounded-pill" style={{ backgroundColor: "#F8F8F8" }}>
                        <Button
                          variant="light"
                          className="me-2 w-50 rounded-pill"
                          style={{
                            backgroundColor: showCategory ? "#471070" : "transparent",
                            color: showCategory ? "white" : "black",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setShowCategory(true);
                            setInputValue("");
                            setShowAdd(true);
                            setShowInput(false);
                          }}
                        >
                          Category
                        </Button>
                        <Button
                          variant="light"
                          className="w-50 rounded-pill"
                          onClick={() => {
                            setShowCategory(false);
                            setInputValue("");
                            setShowAdd(true);
                            setShowInput(false);
                          }}
                          style={{
                            backgroundColor: !showCategory ? "#471070" : "transparent",
                            color: !showCategory ? "white" : "black",
                            cursor: "pointer",
                          }}
                        >
                          Fields
                        </Button>
                      </div>
                      {showCategory ? (
                        <>
                          <p className="mb-1">Categories : {maintenanceList.length}</p>

                          <Form className="my-2">
                            <div
                              className="py-1"
                              style={{
                                maxHeight: "230px",
                                overflowY: "auto",
                              }}
                            >
                              {[...maintenanceList].map((cb, index) => (
                                <Form.Check key={index} className="custom-checkbox ps-5 rounded-3 py-2 w-75 d-flex align-items-center gap-2 mt-2" type="checkbox" label={cb.label} checked={cb.checked} onChange={() => toggleCheckbox(index)} style={{ border: "1px solid #EBEBEB" }} />
                              ))}
                            </div>
                            {showAdd && (
                              <Button
                                className="dark-purple-btn mt-3"
                                onClick={() => {
                                  setShowInput(true);
                                  setShowAdd(false);
                                }}
                              >
                                Add
                              </Button>
                            )}
                            {showInput && (
                              <div className="d-flex gap-3 align-items-end justify-content-between mt-3">
                                <Form.Control placeholder="Enter here..." value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                                <div className="d-flex gap-2 align-items-center">
                                  <div
                                    onClick={() => {
                                      setShowAdd(true);
                                      setShowInput(false);
                                    }}
                                    className="p-3 d-flex align-items-center rounded-circle cursor-pointer"
                                    style={{ border: "1px solid #EBEBEB" }}
                                  >
                                    <img src={close} alt="close" />
                                  </div>
                                  <div
                                    className="p-3 rounded-circle d-flex align-items-center cursor-pointer"
                                    style={{
                                      backgroundColor: "#471070",
                                      cursor: "pointer",
                                    }}
                                    onClick={handleSave}
                                  >
                                    <img src={save} alt="save" />
                                  </div>
                                </div>
                              </div>
                            )}
                          </Form>
                        </>
                      ) : (
                        <>
                          <label htmlFor="vin" className="form-label fw-400 mt-1">
                            Choose category
                          </label>

                          <CommonStaticDropdown items={maintenanceList.filter((item) => item.checked)} placeholder="Select category" value={selectedCategory} onSelect={handleSelectCategory} enableSearch={false} />
                          <Form className="my-2">
                            <div
                              className="py-1"
                              style={{
                                maxHeight: "230px",
                                overflowY: "auto",
                              }}
                            >
                              {categoryField.map((cb, index) => (
                                <Form.Check key={index} className="custom-checkbox ps-5 rounded-3 py-2 w-75 d-flex align-items-center gap-2 mt-2" type="checkbox" label={cb.label} checked={cb.checked} onChange={() => toggleCategoryCheckbox(index)} style={{ border: "1px solid #EBEBEB" }} />
                              ))}
                            </div>
                            {showAdd && (
                              <div className="d-flex justify-content-between">
                                <Button
                                  className="dark-purple-btn mt-3"
                                  onClick={() => {
                                    setShowInput(true);
                                    setShowAdd(false);
                                  }}
                                >
                                  Add
                                </Button>
                                <div className="d-flex gap-3">
                                  <Button className="dark-purple-btn mt-3 rounded-pill py-1 px-4" onClick={addService}>
                                    Save
                                  </Button>
                                </div>
                              </div>
                            )}

                            {showInput && (
                              <div className="d-flex gap-3 align-items-end justify-content-between mt-3">
                                <Form.Control placeholder="Enter here..." value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                                <div className="d-flex gap-2 align-items-center">
                                  <div
                                    onClick={() => {
                                      setShowAdd(true);
                                      setShowInput(false);
                                    }}
                                    className="p-3 d-flex align-items-center rounded-circle cursor-pointer"
                                    style={{ border: "1px solid #EBEBEB" }}
                                  >
                                    <img src={close} alt="close" />
                                  </div>
                                  <div
                                    className="p-3 rounded-circle d-flex align-items-center cursor-pointer"
                                    style={{
                                      backgroundColor: "#471070",
                                      cursor: "pointer",
                                    }}
                                    onClick={handleCategorySave}
                                  >
                                    <img src={save} alt="save" />
                                  </div>
                                </div>
                              </div>
                            )}
                          </Form>
                        </>
                      )}
                    </Modal.Body>
                  </Modal>
                </>
              )}
            </div>
            {activeBtn === "details" && (
              <>
                <div>
                  <DocUploader
                    label="Upload document"
                    description="Add a document here by dragging and dropping, or choose files manually."
                    onFileSelect={(file) => {
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = async () => {
                          const base64String = await reader.result;
                          setAttachmentList([
                            ...attachmentList,
                            {
                              name: file.name,
                              base64: base64String,
                              size: formatBytes(file.size),
                            },
                          ]);
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                  />
                  {attachmentURLList.length > 0 && (
                    <div
                      style={{
                        marginTop: "16px",
                        marginBottom: "16px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "start",
                        gap: "16px",
                      }}
                    >
                      {attachmentURLList.map((item, attachIndex) => (
                        <div
                          key={item.id || attachIndex}
                          style={{
                            width: "312px",
                            height: "62px",
                            borderRadius: "12px",
                            padding: "12px 16px 12px 16px",
                            backgroundColor: "#FFFFFF",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img src={attachment} style={{ width: "37px", height: "36px" }} alt="attachment" />
                          <div
                            style={{
                              width: "240px",
                              marginLeft: "8px",
                              marginTop: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500px",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "2px",
                              }}
                            >
                              {item.name}
                            </span>
                            <br />
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400px",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              {item.size}
                            </p>
                          </div>

                          {item.url && (
                            <div
                              onClick={() => {
                                downloadFile(item.url, item.url.split("/").pop());
                              }}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                              }}
                            >
                              <img
                                src={download}
                                alt="download"
                                style={{
                                  width: "12.8px",
                                  height: "12px",
                                  top: "10px",
                                  left: "9.6px",
                                }}
                              />
                            </div>
                          )}

                          <div
                            style={{
                              position: "relative",
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              marginLeft: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={closeAttachment}
                              style={{
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                              alt="remove"
                              onClick={() => {
                                setRemovedAttachmentList([...removedAttachmentList, item.id]);
                                setAttachmentURLList(attachmentURLList.filter((_, i) => i !== attachIndex));
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {attachmentList.length > 0 && (
                    <div
                      style={{
                        marginTop: "16px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "start",
                        gap: "16px",
                      }}
                    >
                      {attachmentList.map((item, attachIndex) => (
                        <div
                          key={attachIndex}
                          style={{
                            width: "312px",
                            height: "62px",
                            borderRadius: "12px",
                            padding: "12px 16px 12px 16px",
                            backgroundColor: "#FFFFFF",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img src={attachment} style={{ width: "37px", height: "36px" }} alt="attachment" />
                          <div
                            style={{
                              width: "210px",
                              marginLeft: "8px",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                fontWeight: "500px",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "2px",
                              }}
                            >
                              {item.name}
                            </div>
                            <p
                              style={{
                                fontWeight: "400px",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              {item.size}
                            </p>
                          </div>

                          <div
                            style={{
                              position: "relative",
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              marginLeft: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={closeAttachment}
                              style={{
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                              alt="close"
                              onClick={() => {
                                setAttachmentList(attachmentList.filter((_, i) => i !== attachIndex));
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="d-flex flex-xl-nowrap flex-wrap gap-3 mt-2">
                  <div className="vehicle-info bg-white rounded-4 p-3">
                    <p className="fw-600">Vehicle Information</p>
                    <div className="row">
                      <div className="col-xl-6 col-12">
                        <label htmlFor="vin" className="form-label  fw-400 d-flex">
                          Vehicle Identification Number (VIN)
                          <span className="error-text">*</span>
                        </label>
                        <input type="text" className="form-control rounded-3 vehicle-form-input" id="vin" value={vin} onChange={(e) => setvin(e.target.value)} placeholder="Enter here..." />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.vin}</span>

                        <label htmlFor="name" className="form-label  fw-400 mt-3 d-flex">
                          Name<span className="error-text">*</span>
                        </label>
                        <input type="text" className="form-control rounded-3 vehicle-form-input" id="name" value={name} placeholder="Enter here..." onChange={(e) => setname(e.target.value)} />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.name}</span>

                        <label htmlFor="license" className="form-label  fw-400 mt-3 d-flex">
                          License plate<span className="error-text">*</span>
                        </label>
                        <div className="license-input-group">
                          <input
                            type="text"
                            className="license-input"
                            id="license"
                            value={licensePlate}
                            onChange={(e) => {
                              setlicensePlate(e.target.value);

                              if (rcNo) {
                                resetVehicleDetails();
                              }
                            }}
                            placeholder="Enter here..."
                          />

                          {isParivahan && (
                            <button type="button" className="get-info-btn d-flex align-items-center justify-content-center" onClick={getLicenseDetails} disabled={!licensePlate.trim() || loading}>
                              {loading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  Loading...
                                </>
                              ) : id ? (
                                "Update Info"
                              ) : (
                                "Get Info"
                              )}
                            </button>
                          )}
                        </div>
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.lic_no}</span>

                        <label htmlFor="makeinfo" className="form-label  fw-400 mt-3">
                          Make info
                        </label>
                        <div className="d-flex border rounded-3 px-1">
                          <input type="text" className="form-control border-0 rounded-0 border-end vehicle-form-input" id="makeinfo" value={makeBrand} onChange={(e) => setmakeBrand(e.target.value)} placeholder="Make brand" />
                          <input type="text" className="form-control border-0 border-start rounded-0 vehicle-form-input" id="makeinfo" onChange={(e) => setmakeYear(e.target.value)} value={makeYear} placeholder="Make year" />
                        </div>
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.year_of_make}</span>

                        <label htmlFor="trim" className="form-label  fw-400 mt-3">
                          Trim
                        </label>
                        <SearchWithFreeText apiUrl={`${apiUrl}get_trim`} placeholder="Search & type..." selectedValue={selectedTrim} onDropdownChange={handleDropdownTrimChange} onChangeSearch={handleSearchTrimChange} />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.trim}</span>
                      </div>

                      <div className="col-xl-6 col-12">
                        <label htmlFor="code" className="form-label  fw-400 d-flex">
                          Code<span className="error-text">*</span>
                        </label>
                        <input type="text" className="form-control rounded-3 vehicle-form-input" id="code" value={code} onChange={(e) => setcode(e.target.value)} placeholder="Code..." />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.code}</span>

                        <label htmlFor="type" className="form-label  fw-400 mt-3 d-flex">
                          Vehicle Type<span className="error-text">*</span>
                        </label>
                        <SearchWithFreeText apiUrl={`${apiUrl}get_vehicletype`} placeholder="Search..." selectedValue={selectedvehType} onDropdownChange={(option) => setSelectedvehType(option)} onChangeSearch={setSearchVehType} />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.vehicle_type}</span>

                        <label htmlFor="kms" className="form-label  fw-400 mt-3">
                          Kilometer
                        </label>
                        <input type="text" className="form-control rounded-3 vehicle-form-input" id="kms" value={makeKiloMeter} onChange={(e) => setKiloMeter(e.target.value)} placeholder="Enter here..." />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.km}</span>

                        <label htmlFor="model" className="form-label  fw-400 mt-3">
                          Model
                        </label>
                        <input type="text" className="form-control rounded-3 vehicle-form-input" id="model" value={makeModel} onChange={(e) => setModel(e.target.value)} placeholder="Enter here..." />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.model}</span>

                        <label htmlFor="type" className="form-label  fw-400 mt-3">
                          Fuel Type
                        </label>
                        <CommonStaticDropdown items={FUEL_TYPE_LIST} placeholder="Select type" value={selectedFuelType} onSelect={setSelectedFuelType} enableSearch={false} />
                        <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.fuel_type}</span>
                      </div>
                    </div>
                  </div>
                  <div className="vehicle-classi bg-white rounded-4 p-3">
                    <p className="fw-600">Classifications</p>
                    <label htmlFor="type" className="form-label  fw-400 mt-3">
                      Status
                    </label>
                    <CommonStaticDropdown items={STATUS_LIST} placeholder="Select status" value={selectedStatus} onSelect={(item) => setSelectedStatus(item)} enableSearch={false} />
                    <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.status}</span>

                    <label htmlFor="type" className="form-label  fw-400 mt-3">
                      Group location
                    </label>
                    <CommonDropdown apiUrl={`${adminUrl}get_location`} placeholder="Select location" value={selectedLocation} onSelect={(item) => setSelectedLocation(item)} />
                    <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.location}</span>

                    <label htmlFor="type" className="form-label  fw-400 mt-3">
                      Operation
                    </label>
                    <input type="text" className="form-control rounded-3 vehicle-form-input" id="operation" value={operationvalue} onChange={(e) => setoperationvalue(e.target.value)} placeholder="Enter here" />
                    <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.operation}</span>

                    <label htmlFor="type" className="form-label  fw-400 mt-3">
                      Ownership
                    </label>
                    <CommonStaticDropdown items={OWNERSHIP_LIST} placeholder="Select ownership" value={selectedOwnerShip} onSelect={(item) => setSelectedOwnerShip(item)} enableSearch={false} />
                    <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.ownership}</span>
                  </div>
                </div>
                <div className="bg-white my-3 p-3 rounded-4">
                  <p className="fw-600">Additional details</p>
                  <div className="row">
                    <div className="col-xl-3 col-12">
                      <label htmlFor="license" className="form-label  fw-400 mt-3">
                        Color
                      </label>
                      <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" onChange={(e) => setColorvalue(e.target.value)} value={colorvalue} placeholder="Enter here..." />
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.color}</span>
                    </div>
                    <div className="col-xl-3 col-12">
                      <label htmlFor="license" className="form-label  fw-400 mt-3">
                        Body type
                      </label>
                      <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" value={bodytypevalue} onChange={(e) => setbodytypevalue(e.target.value)} placeholder="Enter here..." />
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.body_type}</span>
                    </div>
                    <div className="col-xl-3 col-12">
                      <label htmlFor="license" className="form-label  fw-400 mt-3">
                        Body sub type
                      </label>
                      <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" onChange={(e) => setbodySubtypevalue(e.target.value)} value={bodySubtypevalue} placeholder="Enter here..." />
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.body_sub_type}</span>
                    </div>
                    <div className="col-xl-3 col-12">
                      <label htmlFor="type" className="form-label  fw-400 mt-3">
                        Load Capacity (Kg)
                      </label>
                      <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" value={loadCapacvalue} onChange={(e) => setloadCapacvalue(e.target.value)} placeholder="Enter here..." />
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.load_capacity}</span>
                    </div>
                    <div className="col-xl-3 col-12">
                      <label htmlFor="makeinfo" className="form-label  fw-400 mt-3">
                        Make info
                      </label>
                      <div className="d-flex border rounded-3 px-1">
                        <input type="text" className="form-control border-0 rounded-0 border-end vehicle-form-input" id="makeinfoL" value={moreinfoLvalue} onChange={(e) => setmoreinfoLvalue(e.target.value)} placeholder="L" />
                        <input type="text" className="form-control border-0 border-start rounded-0 vehicle-form-input" id="makeinfoB" value={moreinfoRvalue} onChange={(e) => setmoreinfoRvalue(e.target.value)} placeholder="B" />
                        <input type="text" className="form-control border-0 border-start rounded-0 vehicle-form-input" id="makeinfoH" value={moreinfoHvalue} onChange={(e) => setmoreinfoHvalue(e.target.value)} placeholder="H" />
                        <Dropdown>
                          <Dropdown.Toggle variant="success" id="dropdown-basic" className="bg-transparent w-100 text-black d-flex justify-content-between border-0 border-start gap-3 rounded-0 dp-toggle">
                            {selectedUnit}
                            <span className="text-black">
                              <ChevronDown />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                            {["cm", "meter", "Inch", "ft"].map((u) => (
                              <Dropdown.Item key={u} onClick={() => setSelectedUnit(u)}>
                                {u}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">
                        {errorMsg.uom} {errorMsg.length} {errorMsg.breadth} {errorMsg.height}
                      </span>
                    </div>
                    <div className="col-xl-3 col-12">
                      <label htmlFor="license" className="form-label  fw-400 mt-3">
                        Vehicle value
                      </label>
                      <div className="d-flex border rounded-3 px-1">
                        <Dropdown>
                          <Dropdown.Toggle variant="success" id="dropdown-basic" className="bg-transparent w-100 text-black d-flex justify-content-between border-0 border-end gap-2 rounded-0 dp-toggle">
                            {selectedValueType}
                            <span className="text-black">
                              <ChevronDown />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                            {["INR", "USD", "EURO", "SGD"].map((c) => (
                              <Dropdown.Item key={c} onClick={() => setSelectedValueType(c)}>
                                {c}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                        <input type="number" className="form-control border-0 rounded-0  vehicle-form-input" id="vehiclevalue" onChange={(e) => setVehiclevalue(e.target.value)} value={vehilcevalue} placeholder="Enter here" />
                      </div>
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.vehicle_value}</span>
                    </div>
                    <div className="col-xl-3 col-12">
                      <label htmlFor="license" className="form-label  fw-400 mt-3">
                        Vehicle life time
                      </label>
                      <div className="d-flex border rounded-3 px-1">
                        <input type="number" className="form-control border-0 rounded-0  vehicle-form-input" id="lifetime" value={vehilceLifevalue} onChange={(e) => setVehicleLifevalue(e.target.value)} placeholder="Enter here" />
                        <Dropdown>
                          <Dropdown.Toggle variant="success" id="dropdown-basic" className="bg-transparent w-100 text-black d-flex justify-content-between border-0 border-start gap-2 rounded-0 dp-toggle">
                            {selectedLifeValue}
                            <span className="text-black">
                              <ChevronDown />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                            {["Year", "Month"].map((l) => (
                              <Dropdown.Item key={l} onClick={() => setSelectedLifeValue(l)}>
                                {l}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.lifetime}</span>
                      <span className="error-msg text-danger mt-1 fs-12 d-flex ms-1">{errorMsg.lifetime_period}</span>
                    </div>
                  </div>
                </div>

                {isParivahan && (
                  <div className="container-fluid">
                    <div className="row g-2">
                      {/* RC DETAILS */}
                      <div className="col-md-4">
                        <RCDetailsCard rcNumber={rcNo} onRcNumberChange={setRcNo} expiryDate={expiryDate} onExpiryDateChange={setExpiryDate} status={rcStatus} onStatusChange={setRcStatus} disabled={isFetch} />
                      </div>
                      <div className="col-md-4">
                        <RCDetailsCard title="Insurance details" label="Insurance Company" rcNumber={insNo} onRcNumberChange={setInsNo} expiryDate={expiryInsDate} onExpiryDateChange={setExpiryInsDate} status={insStatus} onStatusChange={setInsStatus} disabled={isFetch} />
                      </div>
                      <div className="col-md-4">
                        <RCDetailsCard title="Permit details" label="Permit Number" rcNumber={permitNo} onRcNumberChange={setPermitNo} expiryDate={expiryPermitDate} onExpiryDateChange={setExpiryPermitDate} status={permitStatus} onStatusChange={setPermitStatus} disabled={isFetch} />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {activeBtn === "maintenance" && (
              <>
                {serviceList.length > 0 && (
                  <div className="row gx-3 gy-3">
                    {serviceList.map((service, index) => (
                      <div key={index} className="col-12 col-xl-6">
                        <div className="bg-white rounded-4 p-4 h-100">
                          <p className="d-flex m-0 fw-600 fs-18">
                            {service.name}
                            <button
                              type="button"
                              onClick={() => handleDeleteService(index)}
                              style={{
                                border: "1px solid #D4DDE7",
                                borderRadius: "50%",
                                background: "transparent",
                                padding: "6px",
                                width: "32px",
                                height: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                marginLeft: "12px",
                              }}
                            >
                              <img src={trash} alt="Trash" style={{ width: "16px", height: "16px" }} />
                            </button>
                          </p>
                          {service.fields.map((field, fIndex) => (
                            <div key={field.id} className="d-flex flex-column gap-1 mt-3">
                              <label htmlFor={`input-kilometer-${field.id}`} className="d-flex align-items-center form-label fs-13 fw-400 mb-0" style={{ gap: "8px" }}>
                                {field.name}
                                <button
                                  type="button"
                                  onClick={() => handleFieldsDelete(index, fIndex)}
                                  style={{
                                    border: "1px solid #D4DDE7",
                                    borderRadius: "50%",
                                    background: "transparent",
                                    padding: "6px",
                                    width: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img src={trash} alt="Trash" style={{ width: "16px", height: "16px" }} />
                                </button>
                              </label>

                              <div className="d-flex flex-row gap-3">
                                <div className="col-6">
                                  <input type="number" className="form-control rounded-3 vehicle-form-input" id={`input-kilometer-${field.id}`} placeholder="Enter here" value={field.kilometer} onChange={(e) => handleServiceFieldChange(index, fIndex, "kilometer", e.target.value)} />
                                </div>
                                <div className="col-6 d-flex border bg-white rounded-3 px-1">
                                  <input type="number" className="form-control bg-transparent border-0 rounded-0 border-end vehicle-form-input" id={`input-period-${field.id}`} placeholder="Enter period" value={field.period} onChange={(e) => handleServiceFieldChange(index, fIndex, "period", e.target.value)} />
                                  <Dropdown>
                                    <Dropdown.Toggle variant="success" id={`dropdown-${field.id}`} className="bg-white w-100 border-0 d-flex justify-content-between dpm-toggle">
                                      {field.periodValue || "Select"}{" "}
                                      <span className="pagination-color">
                                        <ChevronDown />
                                      </span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu
                                      style={{
                                        minWidth: "unset",
                                        width: "100%",
                                      }}
                                    >
                                      {PERIOD_OPTIONS.map((item) => (
                                        <Dropdown.Item key={item} onClick={() => handleServiceFieldChange(index, fIndex, "periodValue", item)}>
                                          {item}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
            {activeBtn === "maintenance" && serviceList.length === 0 && (
              <div
                className=" bg-white "
                style={{
                  width: "100%",
                  height: "120px",
                  borderRadius: "24px",
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
